import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['newContact'];
  static values = {
    siteConfigId: Number,
  };

  connect() {
    console.log('siteconfig admin_contact');
  }

  async update(e) {
    const siteConfigId = e.params.id;
    const input = document.getElementById(e.params.inputValue);

    const body = {
      value: input.value,
    };

    this.callApi(
      `/api/siteconfigs/${siteConfigId}/value`,
      body,
      'PUT',
      (res) => {
        location.reload();
      },
      (err) => {
        window.$reloadAndSendAlert(err.msg);
      },
    );
  }

  callApi(url, body, method, successCallback, failedCallback) {
    fetch(_spring['context_path'] + url, {
      method,
      credentials: 'include',
      headers: Object.assign({}, _csrf, { 'Content-Type': 'application/json' }),
      body: JSON.stringify(body),
    })
      .then(async (res) => {
        if (res.ok) {
          if (Number(res.headers.get('content-length')) === 0) {
            return;
          } else {
            return res.json();
          }
        }
        return Promise.reject(res.json());
      })
      .then((res) => {
        if (successCallback !== undefined && successCallback !== null) {
          successCallback(res);
        }
      })
      .catch((error) => {
        if (failedCallback !== undefined && failedCallback !== null) {
          error.then((err) => {
            failedCallback(err);
          });
        }
      });
  }
}
